import { SnackbarAction, SnackbarKey } from 'notistack'
import React, { FC, MouseEvent, useCallback } from 'react'

import closeIcon from '../../../img/icons/close.svg'

export interface FavoriteToastActionsProps {
  snackbarKey: SnackbarKey
  onUndo?: () => void
  dismissToast: (snackbarKey: SnackbarKey) => void
}

export const getFavoriteToastActions = (
  props: Omit<FavoriteToastActionsProps, 'snackbarKey'>,
): SnackbarAction => {
  const Actions = (snackbarKey: SnackbarKey) => (
    <FavoriteToastActions snackbarKey={snackbarKey} {...props} />
  )
  return Actions
}

export const FavoriteToastActions: FC<FavoriteToastActionsProps> = ({
  snackbarKey,
  onUndo,
  dismissToast,
}) => {
  const closeToast = useCallback(() => dismissToast(snackbarKey), [dismissToast, snackbarKey])

  const handleUndo = useCallback(
    (event: MouseEvent<HTMLElement>) => {
      event.preventDefault()
      event.stopPropagation()
      onUndo?.()
      closeToast()
    },
    [closeToast, onUndo],
  )

  return (
    <div className="flex items-center gap-3">
      {onUndo && (
        <button
          type="button"
          onClick={handleUndo}
          className="font-gotham text-[14px] font-bold uppercase tracking-[0.02em] text-black"
        >
          Undo
        </button>
      )}
      <button type="button" aria-label="Dismiss" onClick={closeToast} className="p-1">
        <img src={closeIcon} alt="" aria-hidden="true" className="h-4 w-4" />
      </button>
    </div>
  )
}
